import { transactionLaneConstants } from "./action-types";

const initialState = {
  getTransactionLaneData: null,
  getTransactionLaneLoading: false,
  getTransactionLaneError: null,
  data: [],
  getIndividualTransactionLoading: false,
  getIndividualTransactionError: false,
  getIndividualTransactionData: {},
  getIndividualTransactionErrorMsg: null,
  uploadedPdfDocSuccess: [],
  uploadedPdfDocLoader: false,

  sendEmailLoading: false,
  sendEmailData: null,
  sendEmailError: false,

  getDoraDocumentsData: [],
  getDoraDocumentsLoading: false,
  getDoraDocumentsError: null,

  getEmail_TemplateData: [],
  getEmail_TemplateLoading: false,
  getEmail_TemplatesError: false,

  doraDocsUrlShorthandData: null,
  doraDocsUrlShorthandLoading: false,
  doraDocsUrlShorthandFailure: null,

  getSharedDocsData: [],
  getSharedDocsLoading: false,
  getSharedDocsError: null,

  addEmailLoading: false,

  propertyDocs: [],
  folderOpenState: {},
  propertDocsError: false,
  propertyDataErrorMsg: null,
  propertDocsLoading: false,

  propertyDocsWithoutSection: [],
  propertDocsWithoutSectionError: null,
  propertyDataWithoutSectionErrorMsg: null,
  propertDocsWithoutSectionLoading: false,

  setLoading: false,
  setError: "",
  clientPortalData: [],

  generateDashboardLinkLoading: false,
  dashboarUrl: "",

  getPreDoraDocumentsData: [],
  getPreDoraDocumentsLoading: false,
  getPreDoraDocumentsError: null,

  docSetTemplateLoading: false,
  docSetTemplateError: false,
  docSetTemplateData: [],

  propertUploadDocs: null,
  propertDocsLoading: false,
  propertDocsError: null,

  updatedPropertyDoc: [],

  triggerTransactionLaneDataApi: null,

  resure_Sign_Docs:null,
  resure_Sign_Loading: false,
  resure_Sign_Error: false,
};

const rtdTransactionLane = (state = initialState, action) => {
  switch (action.type) {
    case transactionLaneConstants.GET_TRANSACTION_LANE_IN_RTD_LOADING:
      return {
        ...state,
        getTransactionLaneLoading: action.getTransactionLaneLoading,
        getTransactionLaneError: null,
      };

    case transactionLaneConstants.GET_TRANSACTION_LANE_IN_RTD_SUCCESS:
      return {
        ...state,
        getTransactionLaneData: action.getTransactionLaneData,
        getTransactionLaneLoading: false,
        getTransactionLaneError: null,
        data: action.getTransactionLaneData,
      };
    case transactionLaneConstants.GET_TRANSACTION_LANE_IN_RTD_FAILURE:
      return {
        ...state,
        getTransactionLaneData: [],
        getTransactionLaneLoading: action.getTransactionLaneLoading,
        getTransactionLaneError: action.getTransactionLaneError,
      };
    // Email Reducer
    case transactionLaneConstants.SEND_EMAIL_LOADING:
      return {
        ...state,
        sendEmailLoading: true,
        sendEmailError: false,
      };
    case transactionLaneConstants.SEND_EMAIL_SUCCESS:
      return {
        ...state,
        sendEmailData: action.sendEmailData,
        sendEmailLoading: false,
        sendEmailError: false,
      };
    case transactionLaneConstants.SEND_EMAIL_FAILURE:
      return {
        ...state,
        sendEmailLoading: false,
        sendEmailError: action.sendEmailError,
      };
    // Dora Docs Reducer
    case transactionLaneConstants.GET_DORA_DOCUMENTS_LOADING:
      return {
        ...state,
        getDoraDocumentsLoading: true,
        getDoraDocumentsError: null,
      };
    case transactionLaneConstants.GET_DORA_DOCUMENTS_SUCCESS:
      let filterdDoraDocs = action.getDoraDocumentsData?.filter((el) => el.contractType === "CO" || el.contractType === "MH_CO") || [];
      return {
        ...state,
        getDoraDocumentsData: action.getDoraDocumentsData,
        getDoraDocumentsLoading: false,
        getDoraDocumentsError: null,
      };
    case transactionLaneConstants.GET_DORA_DOCUMENTS_FAILURE:
      return {
        ...state,
        getDoraDocumentsLoading: false,
        getDoraDocumentsError: null,
      };
    case transactionLaneConstants.UPLOAD_DOCUMENT_PDF_SUCCESS:
      return {
        ...state,
        uploadedPdfDocSuccess: [],
      };
    case transactionLaneConstants.UPLOAD_DOCUMENT_PDF_LOADER:
      return {
        ...state,
        uploadedPdfDocLoader: action.loading,
      };
    case transactionLaneConstants.GET_EMAIL_TEMPLATE_LOADING:
      return {
        ...state,
        getEmail_TemplateLoading: true,
        getEmail_TemplatesError: false,
      };
    case transactionLaneConstants.GET_EMAIL_TEMPLATE_SUCCESS:
      return {
        ...state,
        getEmail_TemplateData: action.getEmail_Templatedata,
        getEmail_TemplateLoading: false,
        getEmail_TemplatesError: false,
      };
    case transactionLaneConstants.GET_EMAIL_TEMPLATE_FAILURE:
      return {
        ...state,
        getEmail_TemplateLoading: false,
        getEmail_TemplatesError: true,
      };

    case transactionLaneConstants.DORADOCS_SHORTHAND_URL_LOADING:
      return {
        ...state,
        doraDocsUrlShorthandLoading: true,
        doraDocsUrlShorthandFailure: false,
      };

    case transactionLaneConstants.DORADOCS_SHORTHAND_URL_SUCCESS:
      return {
        ...state,
        doraDocsUrlShorthandLoading: false,
        doraDocsUrlShorthandFailure: false,
      };
    case transactionLaneConstants.DORADOCS_SHORTHAND_URL_FAILURE:
      return {
        ...state,
        doraDocsUrlShorthandLoading: false,
        doraDocsUrlShorthandFailure: true,
      };
    case transactionLaneConstants.GET_SHARED_DOCS_LOADING:
      return {
        ...state,
        getSharedDocsLoading: true,
        getSharedDocsError: false,
      };
    case transactionLaneConstants.GET_SHARED_DOCS_SUCCESS:
      return {
        ...state,
        getSharedDocsData: action.getSharedDocsData,
        getSharedDocsLoading: false,
        getSharedDocsError: null,
      };
    case transactionLaneConstants.GET_SHARED_DOCS_FAILURE:
      return {
        ...state,
        getSharedDocsData: [],
        getSharedDocsLoading: false,
        getSharedDocsError: null,
      };
    case transactionLaneConstants.ADD_EMAIL_LOADING:
      return {
        ...state,
        addEmailLoading: true,
      };
    case transactionLaneConstants.ADD_EMAIL_ERROR:
      return {
        ...state,
        addEmailLoading: false,
      };
    case transactionLaneConstants.ADD_EMAIL_SUCCESS:
      return {
        ...state,
        addEmailLoading: false,
      };
    case transactionLaneConstants.GET_INDIVIDUAL_TRANSACTION_LOADING:
      return {
        ...state,
        getIndividualTransactionLoading: true,
        getIndividualTransactionData: action.getIndividualTransactionData,
      };
    case transactionLaneConstants.GET_INDIVIDUAL_TRANSACTION_SUCCESS:
      return {
        ...state,
        getIndividualTransactionError: false,
        getIndividualTransactionLoading: false,
        getIndividualTransactionData: action.getIndividualTransactionData,
      };
    case transactionLaneConstants.GET_INDIVIDUAL_TRANSACTION_FAILURE:
      return {
        ...state,
        getIndividualTransactionError: true,
        getIndividualTransactionLoading: false,
        getIndividualTransactionErrorMsg: action.errorMsg,
        getIndividualTransactionData: [],
      };
    case transactionLaneConstants.TRIGGER_INDIVIDUAL_TRANSACTION_FETCH:
      return {
        ...state,
        triggerIndividualTransactionFetch: [],
      };
    case transactionLaneConstants.GET_CLIENT_DOC_LOADING:
      return {
        ...state,
        propertDocsLoading: true,
        propertDocsError: null,
        propertyDocs: [],
      };
    case transactionLaneConstants.GET_CLIENT_DOC_SUCCESS:
      return {
        ...state,
        propertyDocs: action.propertyDocs,
        propertDocsLoading: false,
        propertDocsError: null,
      };
    case transactionLaneConstants.GET_CLIENT_DOC_ERROR:
      return {
        ...state,
        propertyDocs: [],
        propertDocsLoading: false,
        propertDocsError: null,
      };
    case transactionLaneConstants.GET_PROPERTY_DOC_WITHOUT_SECTION_LOADING:
      return {
        ...state,
        propertDocsWithoutSectionLoading: true,
        propertDocsWithoutSectionError: null,
        propertyDocsWithoutSection: [],
      };
    case transactionLaneConstants.GET_PROPERTY_DOC_WITHOUT_SECTION_SUCCESS:
      return {
        ...state,
        propertyDocsWithoutSection: action.propertyDocsWithoutSection,
        propertDocsLoading: false,
        propertDocsWithoutSectionError: null,
      };
    case transactionLaneConstants.GET_PROPERTY_DOC_WITHOUT_SECTION_ERROR:
      return {
        ...state,
        propertyDocsWithoutSection: [],
        propertDocsWithoutSectionLoading: false,
        propertDocsWithoutSectionError: action.propertDocsWithoutSectionError,
      };

    case transactionLaneConstants.EMAIL_FILES_LOADING:
      return {
        ...state,
        emailFilesLoading: true,
        emailFilesError: "",
        emailFilesData: [],
      };
    case transactionLaneConstants.EMAIL_FILES_ERROR:
      return {
        ...state,
        emailFilesLoading: action.emailFilesLoading,
        emailFilesError: action.emailFilesError,
      };
    case transactionLaneConstants.EMAIL_FILES_SUCCESS:
      return {
        ...state,
        emailFilesLoading: false,
        emailFilesError: false,
        emailFilesData: action.payload,
      };
    case transactionLaneConstants.CLIENT_PORTAL_LOADING:
      return {
        ...state,
        setLoading: true,
        setError: "",
        clientPortalData: [],
      };
    case transactionLaneConstants.CLIENT_PORTAL_ERROR:
      return {
        ...state,
        setLoading: action.setLoading,
        setError: action.setError,
      };
    case transactionLaneConstants.CLIENT_PORTAL_SUCCESS:
      return {
        ...state,
        setLoading: false,
        setError: false,
        clientPortalData: action.payload,
      };

    case transactionLaneConstants.GENERATE_DASHBOARD_LINK_LOADING:
      return {
        ...state,
        generateDashboardLinkLoading: true,
      };
    case transactionLaneConstants.GENERATE_DASHBOARD_LINK_SUCCESS:
      return {
        ...state,
        generateDashboardLinkLoading: false,
        dashboarUrl: action.dashboarUrl,
      };
    case transactionLaneConstants.GENERATE_DASHBOARD_LINK_ERROR:
      return {
        ...state,
        generateDashboardLinkLoading: false,
        dashboarUrl: "",
      };
    case transactionLaneConstants.TOGGLE_FOLDER_OPEN_STATE:
      return {
        ...state,
        folderOpenState: {
          ...state.folderOpenState,
          [action.folderId]: !state.folderOpenState[action.folderId],
        },
      };
    case transactionLaneConstants.RESET_FOLDER_OPEN_STATE:
      return {
        ...state,
        folderOpenState: {},
      };
    case transactionLaneConstants.UPLOAD_DOCUMENT_LOADING:
      return {
        ...state,
        propertDocsLoading: true,
        propertDocsError: null,
      };
    case transactionLaneConstants.UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        propertUploadDocs: action.propertUploadDocs,
        updatedPropertyDoc:[],
        propertDocsLoading: false,
        propertDocsError: null,
      };
    case transactionLaneConstants.UPLOAD_DOCUMENT_FAILURE:
      return {
        ...state,
        propertUploadDocs: [],
        propertDocsLoading: false,
        propertDocsError: null,
      };
    case transactionLaneConstants.GET_MOVE_TO_FOLDER_DATA_SUCCESS:
      return {
        ...state,
        moveToFolderData: action.moveToFolderData,
        moveToFolderDataLoading: false,
      };
    case transactionLaneConstants.GET_MOVE_TO_FOLDER_DATA_LOADING:
      return {
        ...state,
        moveToFolderData: [],
        moveToFolderDataLoading: true,
        moveToFolderDataError: false,
      };
    case transactionLaneConstants.GET_MOVE_TO_FOLDER_DATA_ERROR:
      return {
        ...state,
        moveToFolderData: [],
        moveToFolderDataLoading: false,
        moveToFolderDataError: true,
      };

      case transactionLaneConstants.DOWNLOAD_ALL_FILES_AS_ZIP_REQUEST_LOADING:
      return {
        ...state,
        zipDownloadLoading: true,
      }
    case transactionLaneConstants.DOWNLOAD_ALL_FILES_AS_ZIP_REQUEST_SUCCESS:
      return {
        ...state,
        zipDownloadLoading: false,
      }

      case transactionLaneConstants.GET_TEMPLATE_DOC_SET_LOADING:
      return {
        ...state,
        docSetTemplateLoading:true,
        docSetTemplateError: false,
      }
      case transactionLaneConstants.GET_TEMPLATE_DOC_SET_ERROR:
      return {
        ...state,
        docSetTemplateLoading:false,
        docSetTemplateError: true,
      }
      case transactionLaneConstants.GET_TEMPLATE_DOC_SET_SUCCESS:
      return {
        ...state,
        docSetTemplateLoading:false,
        docSetTemplateData: [...state.docSetTemplateData, ...action.docSetTemplateData?.filter(
          (newItem) =>
            !state.docSetTemplateData?.some(
              (existingItem) => existingItem._id === newItem._id
            )
        )],
        docSetTemplateError: false,
      }
      case transactionLaneConstants.GET_PRE_DORA_DOCUMENTS_LOADING:
      return {
        ...state,
        getPreDoraDocumentsLoading: true,
        getPreDoraDocumentsError: null,
      };
    case transactionLaneConstants.GET_PRE_DORA_DOCUMENTS_SUCCESS:
      return {
        ...state,
        getPreDoraDocumentsData: action.getPreDoraDocumentsData,
        getPreDoraDocumentsLoading: false,
        getPreDoraDocumentsError: null,
      };
    case transactionLaneConstants.GET_PRE_DORA_DOCUMENTS_FAILURE:
      return {
        ...state,
        getPreDoraDocumentsLoading: false,
        getPreDoraDocumentsError: true,
      };
    case transactionLaneConstants.TRIGGER_TRANSACTION_LANE_API:
      return {
        ...state,
        triggerTransactionLaneDataApi: [],
      }
      
      case transactionLaneConstants.GET_RESURE_SIGN_DOC_LOADING:
        return {
          ...state,
          resure_Sign_Loading: true,
          resure_Sign_Error: false,
        };
      case transactionLaneConstants.GET_RESURE_SIGN_DOC_SUCCESS:
        return {
          ...state,
          resure_Sign_Docs: action.RE_SureSignDocData,
          resure_Sign_Loading: false,
          resure_Sign_Error: false,
        };
      case transactionLaneConstants.GET_RESURE_SIGN_DOC_ERROR:
    default:
      return state;
  }
};
export { rtdTransactionLane };
